import { serverFetch } from "@core/server";

export function fetchSprZalList() {
  return serverFetch("sprs/zal");
}

export function fetchSprZal(idZal) {
  return serverFetch(`sprs/zal/${idZal}`);
}

export function fetchSprZalWarehouses() {
  return serverFetch("sprs/zal/warehouses");
}

export function createSprZal(bodyData) {
  return serverFetch("sprs/zal", {
    method: "POST",
    bodyData
  });
}

export function saveSprZal(idZal, bodyData) {
  return serverFetch(`sprs/zal/${idZal}`, {
    method: "PUT",
    bodyData
  });
}

export function deleteSprZal(idZal) {
  return serverFetch(`sprs/zal/${idZal}`, {
    method: "DELETE"
  });
}

export function fillSprZalGraf(bodyData) {
  return serverFetch("sprs/zal/graf/fill", {
    method: "POST",
    bodyData
  });
}

export function clearSprZalGraf(bodyData) {
  return serverFetch("sprs/zal/graf/clear", {
    method: "POST",
    bodyData
  });
}

export function fetchSprZalGraf(idZal, beg, end) {
  return serverFetch(`sprs/zal/${idZal}/graf`, { queryParams: { beg, end } });
}

export function fetchSprZalGrafSession(idZal, idStr) {
  return serverFetch(`sprs/zal/${idZal}/graf/${idStr}`);
}

export function createSprZalGrafSession(idZal, bodyData) {
  return serverFetch(`sprs/zal/${idZal}/graf`, {
    method: "POST",
    bodyData
  });
}

export function saveSprZalGrafSession(idZal, idStr, bodyData) {
  return serverFetch(`sprs/zal/${idZal}/graf/${idStr}`, {
    method: "PUT",
    bodyData
  });
}

export function deleteSprZalGrafSession(idZal, idStr) {
  return serverFetch(`sprs/zal/${idZal}/graf/${idStr}`, {
    method: "DELETE"
  });
}

export function fetchSprZalGrafUsl(idZal, idStr) {
  return serverFetch(`sprs/zal/${idZal}/graf/${idStr}/usl`);
}

export function addSprZalGrafUsl(idZal, idStr, idUsl) {
  return serverFetch(`sprs/zal/${idZal}/graf/${idStr}/usl`, {
    method: "POST",
    bodyData: { idUsl }
  });
}

export function replaceSprZalGrafUsl(idZal, idStr, idUsl, newIdUsl) {
  return serverFetch(`sprs/zal/${idZal}/graf/${idStr}/usl/${idUsl}`, {
    method: "PUT",
    bodyData: { idUsl: newIdUsl }
  });
}

export function deleteSprZalGrafUsl(idZal, idStr, idUsl) {
  return serverFetch(`sprs/zal/${idZal}/graf/${idStr}/usl/${idUsl}`, {
    method: "DELETE"
  });
}

export function clearSprZalGrafDay(idZal, fdate) {
  return serverFetch(`sprs/zal/${idZal}/graf/day`, {
    method: "DELETE",
    queryParams: { fdate }
  });
}

export function fetchSprZalGrafFact(idZal, fdate, idStr = 0) {
  return serverFetch(`sprs/zal/${idZal}/graf/fact`, {
    queryParams: { fdate, ...(idStr > 0 ? { idStr } : {}) }
  });
}

export function setSprZalGrafFactIsOk(idZal, bodyData) {
  return serverFetch(`sprs/zal/${idZal}/graf/fact`, {
    method: "PUT",
    bodyData
  });
}

export function setSprZalGrafFactIsOkAll(idZal, fdate, isOk, idStr = 0) {
  return serverFetch(`sprs/zal/${idZal}/graf/fact/all`, {
    method: "PUT",
    queryParams: { fdate, ...(idStr > 0 ? { idStr } : {}) },
    bodyData: { isOk }
  });
}
